import { ChildStep, ParentStep } from '@/types/steps';

export const computeValidRoutePath = (
  steps: readonly ParentStep<unknown>[],
  parentId: string | undefined,
  childId: string | undefined,
): string | null => {
  const getFirstStepPath = (): string => {
    const parent = steps[0];
    if (!parent) {
      return '';
    }

    const { children } = parent;
    if (children.length === 0) {
      return parent.path;
    }

    return `${parent.path}/${children[0].path}`;
  };

  if (!parentId) {
    return getFirstStepPath();
  }

  const currentParent = steps.find(
    (parent: ParentStep<unknown>): boolean => parent.path === parentId,
  );

  if (!currentParent) {
    return getFirstStepPath();
  }

  const { children } = currentParent;
  if (children.length === 0) {
    return currentParent.path;
  }

  const currentChild = children.find(
    (child: ChildStep<unknown>): boolean => child.path === childId,
  );

  if (!currentChild) {
    return [currentParent.path, children[0].path].join('/');
  } else {
    // Child is valid, no need to redirect
    return null;
  }
};
